import classnames from 'classnames/bind';
import { useState } from 'react';
import styles from './index.module.scss';
import QuestionList from './questionList';
import SideBar from './sideBar';
import { useUserInfo } from '@repository/auth/useUserInfo';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
const cx = classnames.bind(styles);

const InterviewPracticeQuestionSelectBodyAcc = () => {
  const { data: userInfo } = useUserInfo();
  const { isAuthorityUser } = useCheckAuthority(userInfo);
  const [selectedCode, setSelectedCode] = useState<string | null>(null);

  return (
    <div className={cx('wrapper')}>
      {isAuthorityUser && <SideBar selectedCode={selectedCode} setSelectedCode={setSelectedCode} />}
      <QuestionList selectedCode={selectedCode} />
    </div>
  );
};

export default InterviewPracticeQuestionSelectBodyAcc;
